import { ReactNode, HTMLAttributes } from "react";

import './CardInfo.scss';

interface CardInfoProps extends HTMLAttributes<HTMLDivElement> {
	variant?: string;
	children: ReactNode;
}

export function CardInfo({children, variant, ...rest}: CardInfoProps) {
	return(
		<div className={`card-info ${variant ? variant : ''}`} {...rest}>{children}</div>
	)
}
